import { computed } from 'vue'
import type { SearchData } from 'src/layouts/core-layout/components/CoreHeader/components/mobile/TheHeader/TheHeader.types'
import type useTheHeaderSite from 'src/layouts/core-layout/components/CoreHeader/components/mobile/TheHeader/composables/useTheHeaderSite'

type HeaderSite = ReturnType<typeof useTheHeaderSite>

export default function useTheHeaderSearchData(site: HeaderSite) {
  const {
    context,
    hasSearch,
    isProbolezny,
    isConsult,
  } = site

  const searchData = computed<SearchData>(() => {
    const requestPath = String(context.request?.path || '')
    const searchQuery = context.request?.GET?.q
    let useRender = hasSearch.value

    if (isConsult.value) {
      useRender = false
    } else if (isProbolezny.value && requestPath === '/' && !searchQuery) {
      useRender = false
    }

    return {
      useRender,
      location: {
        town: {
          id: context.town?.id,
          name: context.town?.name,
          name_pred: context.town?.name_pred,
          translit: context.town?.translit,
          translations: context.town?.translations,
        },
        district: context.district?.translit || '',
        microdistrict: context.microdistrict?.translit || '',
        street: context.street?.translit || '',
        metro: context.metro?.translit || '',
      },
    }
  })

  return {
    searchData,
  }
}
